import { render, staticRenderFns } from "./SideFeedbackButton.vue?vue&type=template&id=6cc6a5ea"
import script from "./SideFeedbackButton.vue?vue&type=script&lang=js"
export * from "./SideFeedbackButton.vue?vue&type=script&lang=js"
import style0 from "./SideFeedbackButton.vue?vue&type=style&index=0&id=6cc6a5ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports